// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectorSkeleton_wrapper__ZJcNi","clickableBlock":"SelectorSkeleton_clickableBlock__3hWIk","value":"SelectorSkeleton_value__BE2Uf"};